export enum BasketEventStatusConstants {
  CREATION = 'CREATION',
  REBALANCE = 'REBALANCE',
  OPTIMIZE = 'OPTIMIZE',
}
